import { render } from "./TreeSelectChildComponent.vue?vue&type=template&id=a164bfe6"
import script from "./TreeSelectChildComponent.vue?vue&type=script&lang=js"
export * from "./TreeSelectChildComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__